import { directionStatus } from '@gmg/gmg-react-components';
import styled from 'styled-components';

export interface SortingOrder {
    direction: directionStatus;
    propertyName: string;
}

//this is a genral CSS setup for our main table Component,
// in ALL CASES must be customised

export const TableContainerCardStyle = styled.div`
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-gutter: stable; /* reserve scrollbar space so content doesn't shift when it appears/disappears */

    border-radius: 8px;
    background:  ${props => props.theme.colors.background};
    padding: 0 var(--table-card-padding) 16px;
    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.10);
    height: var(--app-content-height);

    &::-webkit-scrollbar-track {
        /* has to be set more exactly */
        margin-top: var(--table-scrollbar-track-margin-top);
    }
`;

export const TableContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: var(--app-content-height);
    max-width: var(--table-max-width);
    min-width: 100% ;
    box-sizing: border-box;
    background-color: ${props => props.theme.colors.backgroundPaper};
    &::-webkit-scrollbar-track {
        /* has to be set more exactly */
        margin-top: var(--table-scrollbar-track-margin-top);
    }
    padding: var(--table-card-padding);
`;

export const Thead = styled.thead`
    position: sticky;
    top: 0px;
    z-index: 1; /* stay above transformed row content (e.g. rotated expand icons) when scrolling underneath */

    th {
        height: var(--table-row-height);
        line-height: 2;
        background-color: ${props => props.theme.colors.background};
        text-align: left;
        padding-left: 20px;
    }
`;

export const Table = styled.table`
    border-spacing: 0;
    width: 100%;

    td {
        padding-left: 20px;
        border-top: 1px solid transparent;
        border-bottom: 1px solid transparent;
        height: var(--table-row-height);
        box-sizing: border-box;
    }

    & td:first-child {
        border-left: 1px solid transparent;
    }

    & td:last-child {
        padding-right: 20px;
        border-right: 1px solid transparent;
    }
    .actions {
        width: var(--table-actions-width);
    }
    .arrow-placeholder {
        width: 32px;
        padding-left: 20px;
        padding-right: 16px;
        text-align: center;
        vertical-align: middle;
    }
    .arrow-placeholder + td {
        padding-left: 0;
    }
`;

export const Tr = styled.tr<{ isSelected: boolean; isHeaderRow?: boolean; isClickable?: boolean }>`
    cursor: ${props => (props.isClickable ? 'pointer' : 'default')};

    &:last-child td{
        border-bottom: 1px solid ${props => props.theme.colors.greyContrastMediumLower};
    }

    a {
      text-decoration: none;
    }
    .invisibleSVG svg {
        display: none;
    }

    &:nth-child(odd) {
        background-color: ${props => props.isSelected ? props.theme.colors.background : props.theme.colors.backgroundPaper};
    }
    &:nth-child(even) {
        background-color: ${props => props.isSelected ? props.theme.colors.background : props.theme.colors.background};
    }

    &:hover {
        background-color: ${props => props.theme.colors.highlightLight};

        .invisibleSVG svg {
            display: block;
        }
    }
`;
